<template>
  <div class="preloader">
    <img :src="require(`../../img/preloader.svg`)" alt="preloader" class="preloader__image">
  </div>
</template>

<script>
export default {
  name: "Preloader"
}
</script>

<style scoped>

</style>